function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallScreenshareOni = function SvgCallScreenshareOni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.227 17.502h-7.37a1.8 1.8 0 0 1-1.8-1.8V5.162a1.8 1.8 0 0 1 1.8-1.8H20.2a1.8 1.8 0 0 1 1.8 1.8v10.54a1.8 1.8 0 0 1-1.8 1.8h-7.372v1.536h2.647a.8.8 0 1 1 0 1.6H8.58a.8.8 0 1 1 0-1.6h2.646v-1.536zM20.4 5.162v10.54a.2.2 0 0 1-.2.2H3.856a.2.2 0 0 1-.2-.2V5.162a.2.2 0 0 1 .2-.2H20.2a.2.2 0 0 1 .2.2"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallScreenshareOni);
export default ForwardRef;